import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingLibrary = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Library" + level];
    return BF2GetConfigBasedOutskirtBuilding(config);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingLibrary.ts
// module id = 2164
// module chunks = 3